import React from 'react';

import { Application } from '@src/@types/app';

import NotFound from './404';
import ServerError from './500';

interface IProps {
    statusCode?: number | null;
}

export default function Error({ statusCode }: IProps) {
    if (statusCode === 404) {
        return <NotFound />;
    }
    return <ServerError />;
}

Error.getInitialProps = ({ res, err }: Application.ReduxNextPageContext): IProps => {
    if (res) {
        return { statusCode: res.statusCode };
    }
    return { statusCode: err ? err.statusCode : null };
};
